/**
 * When to reload the site list. It is loaded once; health is polled. The list is reloaded
 * when the user returns to a stale page, or when health mentions sites the list doesn't have.
 */

export const SITES_STALE_AFTER_MS = 5 * 60 * 1000;
export const UNMATCHED_RELOAD_THROTTLE_MS = 60 * 1000;

export type SitesReloadTrigger = 'visible' | 'unmatched-health';

export interface SitesReloadInput {
  readonly trigger: SitesReloadTrigger;
  readonly now: number;
  /** When the list last loaded successfully */
  readonly loadedAt: number | null;
  /** When the list was last requested, successfully or not */
  readonly lastRequestedAt: number | null;
}

function assertNever(value: never): never {
  throw new Error(`Unexpected trigger: ${String(value)}`);
}

export function shouldReloadSites(input: SitesReloadInput): boolean {
  switch (input.trigger) {
    case 'visible':
      return input.loadedAt !== null && input.now - input.loadedAt > SITES_STALE_AFTER_MS;
    case 'unmatched-health':
      return (
        input.lastRequestedAt === null ||
        input.now - input.lastRequestedAt >= UNMATCHED_RELOAD_THROTTLE_MS
      );
    default:
      return assertNever(input.trigger);
  }
}
